import { Dispatch, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useUnmount } from 'react-use';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import { knmErknmSetFieldsForApproving } from '../actions/knmErknmActions';
import { getApprovingFieldsStatus } from '../common/getApprovingFieldsStatus';
import { IFieldForApprovingContext } from '../constants/fieldsForApproving';

export function useKnmInitFillInProcessFields(context: IFieldForApprovingContext) {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffect(() => {
    dispatch(knmErknmSetFieldsForApproving(getApprovingFieldsStatus(context)));
  }, [dispatch, context]);

  useUnmount(() => {
    dispatch(knmErknmSetFieldsForApproving(undefined));
  });
}
